import TicketApi from '../api/ticketsApi';

export const completeTicketWorkflowTask = async (ticketId, workflowTaskData) => {
    var response = await TicketApi.create().completeWorkflowTask(ticketId, workflowTaskData);
    if (response && response.ok && response.data) {
        return response.data;
    } else {
        return null;
    }
}